// @flow
import FloatingMenu from './FloatingMenu';
export default FloatingMenu;
export type { Props as FloatingMenuProps } from './FloatingMenu';
export type { FloatingMenuItem, FloatingMenuGetLabelForItem } from './types';
